// Size Guide popup (layout/theme.liquid): the "Size Guide" section group shown in a modal on product pages.
// Opened by the Size block's guide link (<modal-opener data-modal="#SizeGuideModal">). Reuses ModalDialog
// (global.js) for Esc, backdrop click, focus trap and focus return.
if (!customElements.get('size-guide-modal') && customElements.get('modal-dialog')) {
  class SizeGuideModal extends customElements.get('modal-dialog') {
    // ModalDialog's connectedCallback reads the parent section; this modal lives in the layout.
    connectedCallback() {}
  }
  customElements.define('size-guide-modal', SizeGuideModal);

  // Theme editor: selecting a section in the Size Guide group opens the popup so edits are visible.
  if (window.Shopify && window.Shopify.designMode) {
    const sizeGuide = (event) => {
      const modal = document.getElementById('SizeGuideModal');
      return modal && event.target && modal.contains(event.target) ? modal : null;
    };
    document.addEventListener('shopify:section:select', (event) => {
      const modal = sizeGuide(event);
      if (modal && !modal.hasAttribute('open')) modal.show(document.activeElement);
    });
    document.addEventListener('shopify:section:deselect', (event) => {
      const modal = sizeGuide(event);
      if (modal && modal.hasAttribute('open')) modal.hide();
    });
  }
}
